<app-menu></app-menu>

<section class="controlflow-page">
  <header class="page-header">
    <div>
      <p>Workflows / Sequências</p>
      <h1>ControlFlow</h1>
      <small>Automatize rotinas entre módulos e acompanhe cada etapa em um único fluxo.</small>
    </div>
    <div class="actions">
      <button class="btn primary" type="button" routerLink="/controlflow/novo">Cadastrar workflow</button>
    </div>
  </header>

  <section class="metric-grid">
    <article class="metric-card accent-blue">
      <div class="metric-icon">
        <mat-icon>schema</mat-icon>
      </div>
      <div>
        <p>Workflows</p>
        <strong>{{ totalWorkflows }}</strong>
        <small>Total cadastrados</small>
      </div>
    </article>
    <article class="metric-card accent-green">
      <div class="metric-icon">
        <mat-icon>play_circle</mat-icon>
      </div>
      <div>
        <p>Ativos</p>
        <strong>{{ activeWorkflows }}</strong>
        <small>Em execução</small>
      </div>
    </article>
    <article class="metric-card accent-slate">
      <div class="metric-icon">
        <mat-icon>account_tree</mat-icon>
      </div>
      <div>
        <p>Etapas</p>
        <strong>{{ totalSteps }}</strong>
        <small>Configuradas</small>
      </div>
    </article>
  </section>

  <section class="workflow-grid">
    <article class="workflow-card" *ngFor="let flow of workflows">
      <div class="workflow-header">
        <div>
          <strong>{{ flow.name }}</strong>
          <small>{{ flow.description || 'Sem descrição' }}</small>
        </div>
        <span class="status-pill" [class.active]="flow.status === 'ATIVO'">
          {{ flow.status === 'ATIVO' ? 'Ativo' : 'Inativo' }}
        </span>
      </div>
      <div class="workflow-meta">
        <span>Tipo: {{ flow.workflow_type === 'CHATBOT' ? 'ChatBot' : 'Processo' }}</span>
        <span>Disparo: {{ flow.trigger }}</span>
        <span>Etapas: {{ flow.steps }}</span>
        <span>Última execução: {{ flow.last_run_at ? (flow.last_run_at | date:'dd/MM/yyyy HH:mm') : '—' }}</span>
      </div>
      <div class="workflow-actions">
        <button class="btn ghost" type="button" [routerLink]="['/controlflow', flow.id]">Ver fluxograma</button>
        <button class="btn secondary" type="button">Executar</button>
      </div>
    </article>
    <p class="empty" *ngIf="!workflows.length">Nenhum workflow cadastrado.</p>
  </section>
</section>
